import getCart from './getCart';

const getHasCart = state => Boolean(getCart(state));

export default getHasCart;
